import {SORTABLE_DIRECTION} from '../../constants';

import type {SortableDirection, ClientRectObject} from '../../typedef';

type IsOutOfContainer = (params: {
    rectContainer: DOMRect | null,
    offsetDragElement: {top: number, left: number},
    cursorCoordinates: {x: number, y: number},
    direction: SortableDirection,
    allowedDragArea?: ClientRectObject | null,
}) => boolean;

export const isOutOfContainer: IsOutOfContainer =
    ({rectContainer, offsetDragElement, cursorCoordinates, direction, allowedDragArea}) => {
        if (allowedDragArea) {
            const isAllowedTopPosition = allowedDragArea?.top < cursorCoordinates.y;
            const isAllowedBottomPosition = allowedDragArea?.bottom > cursorCoordinates.y;
            const isAllowedRightPosition = allowedDragArea?.right > cursorCoordinates.x;
            const isAllowedLeftPosition = allowedDragArea?.left < cursorCoordinates.x;
            return !(
                isAllowedTopPosition
                && isAllowedBottomPosition
                && isAllowedRightPosition
                && isAllowedLeftPosition
            );

        } else if (rectContainer) {
            const startPosition = direction === SORTABLE_DIRECTION.HORIZONTAL ?
                offsetDragElement?.top : offsetDragElement?.left;
            const containerSize = direction === SORTABLE_DIRECTION.HORIZONTAL ?
                rectContainer?.height : rectContainer?.width;
            const cursorPosition = direction === SORTABLE_DIRECTION.HORIZONTAL ?
                cursorCoordinates.y : cursorCoordinates.x;
            const pointerPosition = cursorPosition - startPosition;
            return Math.abs(pointerPosition) >= Number(containerSize);
        }

        return false;
    };
